import {useRerender} from "./useRerender";
import {useRef} from "react";

export function usePersistent<T>(initialValue?: T, onUpdate?: false | ((value: T) => void)): [() => T | undefined, (nextValue?: T) => void] {
    const ref = useRef<T>(initialValue);
    const rerender = useRerender();

    const _get = () => ref.current;

    const _update = (nextValue: T) => {
        if (nextValue === ref.current) return;
        if (typeof onUpdate === "function") onUpdate(nextValue);
        if (typeof onUpdate === "undefined") rerender();

        ref.current = nextValue;
    };

    return [_get, _update];
}
